import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import MultistepWizard from '../multiStepWizard/MultistepWizard';
import PatientDetails from './SubPageWidgets/PatientDetails';
import OriginDestination from './SubPageWidgets/OriginDestination';
import PickDropTime from './SubPageWidgets/PickDropTime';
import Allergies from './SubPageWidgets/Allergies';
import Conditions from './SubPageWidgets/Conditions';
import Observations from './SubPageWidgets/Observations';
import Medications from './SubPageWidgets/Medications';
import ReviewAndSubmit from './SubPageWidgets/ReviewAndSubmit';
import { showNavbar } from '../../store/modules/appStateSlice';
import { useDispatch } from 'react-redux';
import api from '../../store/api';
import { useHistory } from "react-router-dom";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ClearIcon from '@material-ui/icons/Clear';
import Select from '@material-ui/core/Select';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { MenuItem } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const compMap = {
    "Patient Details": PatientDetails,
    "Origin & Destination": OriginDestination,
    "Pickup/Dropoff Time": PickDropTime,
    "Allergies": Allergies,
    "Conditions": Conditions,
    "Observations": Observations,
    "Medications": Medications,
    "Review & Submit": ReviewAndSubmit,
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(0),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
        listItemTextPrimary: {
            fontSize: 46,
            fontWeight: 700
        },
        listItemTextSecondary: {
            fontSize: 24,
            fontWeight: 700,
        },
        needsPoint: {
            fontSize: 19,
            fontWeight: 400,
        },
        badge: {
            borderRadius: 0
        },
        submitButtonLabel: {
            textTransform: 'capitalize',
            fontSize: 18,
            fontWeight: 400,
            color: "#FFF"
        },
        buttonRoot: {
            backgroundColor: '#F4B827',
            color: '#03090E',
            '&:hover': {
                backgroundColor: '#F4B827',
            },
            fontWeight: 'bold',

        },
        formControlLabel: {
            fontSize: 18,
            color: '#4A4A4A',
            padding: theme.spacing(0, 0, 1, 0)

        },
        container: {
            backgroundColor: '#00152e',
            backgroundSize: '100%',
            borderRadius: '0',
            width: '100%',
            padding: 60,
        },
        headerContainer: {
            display: 'flex',
        },
        button: {
            width: '100%',
        },
        fieldTitle: {
            marginBottom: 5,
            color: '#03090E',
        },

        textFieldInput: {
            backgroundColor: '#ECECEC',
            color: 'black',
            height: 44,
            outlined: {
                fontSize: 100,
                transform: 'translate(16px, 13px) scale(1)',
            },
        },
        dialogPaper: {
            minWidth: 500,
            margin: 0,
            borderRadius: 0,
            shadow: 'none',
            backgroundColor: '#fff',
        },
        email: {
            fontFamily: "'Lato', sans-serif;",
            fontSize: 18,
            color: '#03090E',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 30,
        },
        modalTitle: {
            fontSize: 19,
            color: '#03090E',
        },

        MuiInputLabel: {
            color: '#03090E',
            outlined: {
                fontSize: 100,
                transform: 'translate(16px, 13px) scale(1)',
            },
            shrink: {
                transform: 'translate(16px, 13px) scale(1)',
            },
        },
        textFieldLabel: {
            color: '#03090E',
            transform: 'translate(16px, 13px) scale(1)',

            shrink: {
                fontSize: 100,
            },

        },
        selectField: {
            height: 40,

        },
        helpText: {
            color: 'red',
            padding: theme.spacing(0, 0, 0, 2)
        },

    }),
);

const checkifTransferExistsOnPalnner = (trasferId: string, transfers: any[] | null): boolean =>{
    if(!trasferId || !transfers) return false;

    const transferOnPalnner = transfers!!.find(t => t.transferId === trasferId && t.tripPlannerId)
    return transferOnPalnner? true : false;
}

const EditBooking = () => {
    const history = useHistory();
    const { bookingid, transferid } = useParams<{ bookingid: string, transferid: string }>();
    const [invalidBookingID, setInvalidBookingID] = useState(false);
    const [existsOnPlanner, setExistsOnPlanner] = useState(false);
    const classes = useStyles();
    const stepState = React.useState(0);
    const formState = React.useState({});
    const saveChangesState = React.useState(() => () => null);
    const dispatch = useDispatch();

    dispatch(showNavbar(false));

    const getEditBooking = async () => {
        api.getEditBooking(`BookingId=${bookingid}&TransferId=${transferid}`).then((result: any) => {
            
            if (!result.data.errorRaised) {
                result = result.data.model;
                result.reasonForThisTime += "";
                result.PatientHasNoMedicalConditions = result.patientHasNoMedicalConditions;
                result.PatientHasNoAllegies = result.patientHasNoAllegies;
                result.estimateWeight = result.estimatedWeight || false;
                result.GirthIsOver90CM = result.girthIsOver90CM;
                setExistsOnPlanner(checkifTransferExistsOnPalnner(transferid, result.transfers));
                formState[1](result);
            } else {
                setInvalidBookingID(true);
            }
        }).catch((error) => {
            setInvalidBookingID(true);
        })
    }

    const getLocationsData = async (): Promise<void> => {
        try {
            const res = await api.getCustomerLocations('');
            localStorage.setItem('customerLocations', JSON.stringify(res.data.model));
        }
        catch
        {

        }
    }

    const getRecentlyUsedLocations = async (): Promise<void> => {
        try {

            const res = await api.getRecentlyUsedLocations('');
            localStorage.setItem('recentLocations', JSON.stringify(res.data.model));
        }
        catch
        {

        }
    }

    const getMedicationRoutes = async (): Promise<void> => {
        try {

            const res = await api.getRoutes('');
            localStorage.setItem('medicationRoutes', JSON.stringify(res.data.model));
        }
        catch
        {

        }
    }

    const cancelBooking = (): void => {
        history.goBack()
    }

    useEffect(() => {
        getEditBooking();
        getLocationsData();
        getRecentlyUsedLocations();
        getMedicationRoutes();
    }, [])
    return (
        <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
            <MultistepWizard
                formState={formState}
                stepState={stepState}
                components={compMap}
                saveChangesState={saveChangesState}
                isEdit={true}
                onCancel={cancelBooking}
                existsOnPlanner={existsOnPlanner}
            />
            <Dialog classes={{ paper: classes.dialogPaper }} maxWidth="sm" open={invalidBookingID} onClose={() => null} aria-labelledby="form-dialog-title">

                <DialogContent>
                    <div className={classes.header}>
                        <div className={classes.modalTitle}>Some Error Occured</div>
                        <ClearIcon onClick={() => history.push('/transferschedule')} style={{ cursor: "pointer" }} />
                    </div>
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={8}>

                        </Grid>
                    </Grid>
                    <div style={{ margin: '10px 0px 10px 0px' }}>
                        Provided booking ID is not valid.
                    </div>
                </DialogContent>

                <DialogActions>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <Button className={classes.button} onClick={() => history.push('/')} style={{ fontWeight: 'bold', backgroundColor: '#ECECEC', color: '#090F15' }} color="primary">
                                Go To Home
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button className={classes.button} disabled={false} onClick={() => history.push('/transferschedule')}
                                type='submit' style={{ fontWeight: 'bold' }} color="primary">
                                Go to Tranfers
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>

            </Dialog>
        </div>
    );
}

export default EditBooking;